import styled from 'styled-components';

export const PageContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: 'center';
  justify-content: center;
  width: 100dvw;
  height: 100%;
  padding: 4rem 0;
  background-color: ${({ theme }) => theme.colors.white};
  position: relative;
`;

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  gap: 2rem;
  max-width: 768px;
  height: 100%;
  padding: 1rem 0 4rem;
`;

export const Status = styled.div`
  h2 {
    font-size: 1.5em;
  }
`;

export const SipButton = styled.button<{ disconnected: boolean }>`
  display: ${(props) => (props.disconnected ? 'block' : 'none')};
  margin-bottom: 2rem;
  color: ${(props) => props.theme.colors.buttonText};
  padding: 0.8rem 2rem;
  font-size: 1.2rem;
  border: none;
  border-radius: 1.2rem;
  background-color: ${(props) => props.theme.colors.main};
  position: absolute;
  top: 0;
  left: 50%;
  transform: translateX(-50%);
  cursor: pointer;
`;

export const StatusDisplay = styled.div`
  margin-top: 1.4rem;
  position: absolute;
  top: 0%;
  left: 50%;
  transform: translateX(-50%);
  font-weight: 500;

  display: flex;
  flex-direction: column;
  gap: 1rem;

  width: 95%;
  max-width: 500px;
  background-color: ${({ theme }) => theme.colors.grayButton};
  border-radius: 1rem;
  padding: 2rem;
  color: ${({ theme }) => theme.colors.txt100};
  font-size: 2rem;
`;

export const CallTime = styled.div`
  font-size: 1.4rem;
  font-weight: normal;
  color: ${({ theme }) => theme.colors.txt200};
`;

export const PhoneContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-end;
  gap: 2.4rem;
`;

export const PhoneDisplay = styled.input`
  text-align: center;
  font-size: 3.8rem;
  font-weight: 700;
  color: ${({ theme }) => theme.colors.black};
  max-width: 90dvw;
  box-sizing: border-box;
  min-height: 4rem;
`;

export const KeypadContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;

export const Keypad = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr); // 버튼 크기를 동적으로 설정
  width: 100%; // 부모 컨테이너에 맞춤
  row-gap: 1rem; // 세로 간격
  column-gap: 3.6rem; // 가로 간격

  & > :nth-last-child(-n + 3) {
    margin-top: 1rem; // 마지막 줄에 추가 간격 적용
  }
`;

export const Button = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 6.4rem;
  height: 6.4rem;
  border-radius: 100%;
  cursor: pointer;
  font-size: 2.8rem;
  font-weight: 600;
  color: ${({ theme }) => theme.colors.black};

  transition: transform 0.1s ease-in-out;
  &:active {
    transform: scale(0.9);
    background-color: ${({ theme }) => theme.colors.buttonDisabledBg};
  }
`;

export const BackspaceButton = styled.button<{ phoneNumber: boolean }>`
  opacity: ${(props) => (props.phoneNumber ? 1 : 0)};
  transition:
    opacity 0.2s ease,
    transform 0.2s ease;
  color: ${({ theme }) => theme.colors.black};

  font-size: 3rem;
  width: 7.4rem;
  height: 7.4rem;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const CallButton = styled(Button)`
  background-color: #30d158;
  color: ${(props) => props.theme.colors.white};
  border-radius: 100%;
  display: flex;
  justify-content: center;
  align-items: center;

  transition: transform 0.1s ease-in-out;
  &:active {
    transform: scale(0.9);
  }
`;

export const EndCallButton = styled(Button)`
  background-color: #f44336;
  color: ${(props) => props.theme.colors.white};
  border-radius: 100%;
  display: flex;
  justify-content: center;
  align-items: center;

  transition: transform 0.1s ease-in-out;
  &:active {
    transform: scale(0.9);
  }
`;

export const MuteButton = styled(Button)<{ isMuted: boolean }>`
  background-color: ${({ isMuted, theme }) => (isMuted ? theme.colors.gray200 : theme.colors.gray100)};
  color: ${({ isMuted, theme }) => (isMuted ? theme.colors.red : theme.colors.black)};
  border-radius: 100%;
  display: flex;
  justify-content: center;
  align-items: center;

  transition:
    transform 0.1s ease-in-out,
    background-color 0.2s ease-in-out;
  &:active {
    transform: scale(0.9);
  }
`;

export const SpeakerButton = styled(Button)<{ $isSpeaker: boolean }>`
  background-color: ${({ $isSpeaker, theme }) => ($isSpeaker ? theme.colors.gray200 : theme.colors.gray100)};
  color: ${({ $isSpeaker, theme }) => ($isSpeaker ? theme.colors.blue : theme.colors.black)};
  border-radius: 100%;
  display: flex;
  justify-content: center;
  align-items: center;

  transition:
    transform 0.1s ease-in-out,
    background-color 0.2s ease-in-out;
  &:active {
    transform: scale(0.9);
  }
`;

//오디오 태그
export const AudioElement = styled.audio``;

// 검색된 데이터

export const BuddyListContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  overflow-y: auto;
  flex: 1;
`;

export const BuddyListItem = styled.div`
  color: ${({ theme }) => theme.colors.black};
  width: fit-content;
  display: flex;
  align-items: center;
  gap: 1.4rem;
  font-size: 1.8rem;
  font-weight: 600;
  color: ${({ theme }) => theme.colors.txt500};
  padding: 0.6rem;

  &:hover {
    background-color: ${({ theme }) => theme.colors.gray200};
    cursor: pointer;
  }
`;

export const BuddyIcon = styled.div<{ bgColor: string }>`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0.6rem;
  border-radius: 100%;
  background-color: ${({ bgColor }) => bgColor};
  color: white;
`;

export const BuddyName = styled.div`
  width: 8ch;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
`;

export const BuddyNumber = styled.div`
  width: 12ch;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
`;

export const SwipeCallWrap = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 6.4rem;
  height: 6.4rem;
`;

export const SwipeCallSpan = styled.span`
  display: block;
  width: 6.4rem;
  height: 1rem;
  border-top: 2px dashed ${({ theme }) => theme.colors.gray300};
  border-image: linear-gradient(
    90deg,
    ${({ theme }) => theme.colors.gray300} 25%,
    transparent 50%,
    ${({ theme }) => theme.colors.gray300} 75%
  );
  border-image-slice: 1;
  animation: wave 1s ease-in-out infinite;

  @keyframes wave {
    0% {
      border-image-source: linear-gradient(
        90deg,
        ${({ theme }) => theme.colors.gray300} 25%,
        transparent 50%,
        ${({ theme }) => theme.colors.gray300} 75%
      );
    }
    50% {
      border-image-source: linear-gradient(
        90deg,
        transparent 25%,
        ${({ theme }) => theme.colors.gray300} 50%,
        transparent 75%
      );
    }
    100% {
      border-image-source: linear-gradient(
        90deg,
        ${({ theme }) => theme.colors.gray300} 25%,
        transparent 50%,
        ${({ theme }) => theme.colors.gray300} 75%
      );
    }
  }
`;
